__turbopack_context__.v({
  "aligncenter": "postBody-module-scss-module__BMzCoa__aligncenter",
  "alignleft": "postBody-module-scss-module__BMzCoa__alignleft",
  "alignright": "postBody-module-scss-module__BMzCoa__alignright",
  "bodyContent": "postBody-module-scss-module__BMzCoa__bodyContent",
  "btn": "postBody-module-scss-module__BMzCoa__btn",
  "buttonContainer": "postBody-module-scss-module__BMzCoa__buttonContainer",
  "continueReading": "postBody-module-scss-module__BMzCoa__continueReading",
  "continueReadingContainer": "postBody-module-scss-module__BMzCoa__continueReadingContainer",
  "ctaButton": "postBody-module-scss-module__BMzCoa__ctaButton",
  "helpCenter": "postBody-module-scss-module__BMzCoa__helpCenter",
  "hideOverflow": "postBody-module-scss-module__BMzCoa__hideOverflow",
  "postBody": "postBody-module-scss-module__BMzCoa__postBody",
  "sharIcons": "postBody-module-scss-module__BMzCoa__sharIcons",
  "wpVideo": "postBody-module-scss-module__BMzCoa__wpVideo",
});
